import { ROLE_NAME } from "../constants/roleName"
export const getRoleName = (roleName) => {
    return ROLE_NAME[Object.keys(ROLE_NAME).find(key => key === roleName)];
}